import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { WatchlistFilter } from '@sorare/core/src/__generated__/globalTypes';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { iconPlus } from '@sorare/core/src/atoms/icons/system/iconPlus.ts';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { HeadlineS, LabelL } from '@sorare/core/src/atoms/typography';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

import { AddWatchlistButton } from '#src/components/watchlists/AddWatchlistButton/index.tsx';

const Root = styled(Vertical)`
  @media ${tabletAndAbove} {
    grid-column: 2 / 10;
    &.${WatchlistFilter.FOLLOWED_WATCHLISTS} {
      grid-column: 1/10;
    }
  }
`;

const Border = styled(Vertical)`
  flex-grow: 1;
  border: 1px dashed var(--c-nd-150);
  border-radius: var(--double-unit);
  padding: calc(var(--unit) * 6);
`;

const Placeholder = styled.div`
  height: 46px;
`;

const StyledHeadlineS = styled(HeadlineS)`
  word-break: break-word;
`;

type Props = {
  search: string;
  onAddWatchlist: () => void;
  watchlistsFilter: WatchlistFilter;
};

export const EmptyState = ({
  search,
  onAddWatchlist,
  watchlistsFilter,
}: Props) => {
  const onlyFollowedWatchlists =
    watchlistsFilter === WatchlistFilter.FOLLOWED_WATCHLISTS;
  return (
    <Root gap={1.5} className={watchlistsFilter}>
      <Border center gap={2}>
        <Vertical className="text-center" gap={0.5}>
          <StyledHeadlineS>
            {search ? (
              <FormattedMessage
                defaultMessage="No watchlists found for “{search}”"
                values={{ search }}
              />
            ) : (
              <FormattedMessage defaultMessage="No watchlists found" />
            )}
          </StyledHeadlineS>
          {!search && !onlyFollowedWatchlists && (
            <LabelL color="var(--c-nd-600)">
              <FormattedMessage defaultMessage="Create watchlists to track and organize your favorite players effortlessly" />
            </LabelL>
          )}
        </Vertical>
        {!search && !onlyFollowedWatchlists && (
          <Horizontal center>
            <AddWatchlistButton
              startIcon={<FontAwesomeIcon icon={iconPlus} size="lg" />}
              size="medium"
              color="secondary"
              onSuccess={onAddWatchlist}
            />
          </Horizontal>
        )}
      </Border>
      <Placeholder />
    </Root>
  );
};
